import React, { useState, useEffect } from "react";
import "./Form.scss";
import attentionimage from "./attention.png";

const Form = ({ userData }) => {
  const [discordName, setDiscordName] = useState("");
  const [discordId, setDiscordId] = useState("");
  const [age, setAge] = useState("");
  const [description, setDescription] = useState("");
  const [interaction, setInteraction] = useState("");
  const [goodRoleplay, setGoodRoleplay] = useState("");
  const [events, setEvents] = useState("");
  const [socialCulturalTraits, setSocialCulturalTraits] = useState("");
  const [technologies, setTechnologies] = useState("");
  const [npcInteraction, setNpcInteraction] = useState("");
  const [uncomfortableScene, setUncomfortableScene] = useState("");
  const [injury, setInjury] = useState("");
  const [injuryDescription, setInjuryDescription] = useState("");
  const [ideas, setIdeas] = useState("");
  const [groupSize, setGroupSize] = useState("");
  const [playStyle, setPlayStyle] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [allFieldsAreFilled, setAllFieldsAreFilled] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  useEffect(() => {
    const formFields = [
      discordName,
      discordId,
      age,
      description,
      interaction,
      goodRoleplay,
      events,
      socialCulturalTraits,
      technologies,
      npcInteraction,
      uncomfortableScene,
      injury,
      injuryDescription,
      ideas,
      groupSize,
      playStyle,
    ];
    const allFieldsAreFilled = formFields.every((field) => field);
    // console.log(allFieldsAreFilled);
    setAllFieldsAreFilled(allFieldsAreFilled);
  }, [
    discordName,
    discordId,
    age,
    description,
    interaction,
    goodRoleplay,
    events,
    socialCulturalTraits,
    technologies,
    npcInteraction,
    uncomfortableScene,
    injury,
    injuryDescription,
    ideas,
    groupSize,
    playStyle,
  ]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData();
    data.append('discordName', discordName);
    data.append('discordId', discordId);
    data.append('age', age);
    data.append('description', description);
    data.append('interaction', interaction);
    data.append('goodRoleplay', goodRoleplay);
    data.append('events', events);
    data.append('socialCulturalTraits', socialCulturalTraits);
    data.append('technologies', technologies);
    data.append('npcInteraction', npcInteraction);
    data.append('uncomfortableScene', uncomfortableScene);
    data.append('injury', injury);
    data.append('injuryDescription', injuryDescription);
    data.append('ideas', ideas);
    data.append('groupSize', groupSize);
    data.append('playStyle', playStyle);

    fetch("./send.php", {
      method: "POST",
      // credentials: "include",
      body: data,
    })
      .then(response => response.json())
      .then(data => {
        if (data.status == "successfully") {
          const inputs = document.getElementsByTagName("input");
          for (let i = 0; i < inputs.length; i++) {
            inputs[i].value = null;
          }

          const textareas = document.getElementsByTagName("textarea");
          for (let i = 0; i < textareas.length; i++) {
            textareas[i].value = null;
          }
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
          setTimeout(() => {
            alert("Twoje podanie zostało pomyślnie wysłane!")
          }, 2000);

        } else if (data.status == "blacklist") {
          alert("Niestety nie możesz wysłąć podania ponieważ znajdujesz się na czarnej liście. Powód:" + data.reason || "")
        } else if (data.status == "error") {
          alert("Coś poszło nie tak spróbuj ponownie późnij lub zgłoś się do administracji. Możesz też skopiować i zapisać swoje odpowiedzi")
        } else if (data.status == "missingField") {
          alert("Wygląda na to że jakieś pole jest puste sprawdź swoje podanie raz jeszcze")
        }
        // console.log(data);
      })
      .catch((error) => console.error(error));
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Twój STEAMID64:
        <input
          type="number"
          disabled
          value={userData.steamid}
        />
      </label>
      <label>
        Twoja nazwa na discord:
        <input
          placeholder="YoungTimmy321"
          type="text"
          value={discordName}
          onChange={(e) => setDiscordName(e.target.value)}
        />
      </label>
      <label>
        <div className="attention-box">
          <img src={attentionimage} alt="" />
          <h3>Jak sprawdzić Discord ID.</h3>
          <span>
            Możesz to zrobić za pomocą specjalnego kanału na naszym discordzie
            WildLandsRP.pl, który po kliknięciu w przycisk wyświetli ci twój
            identyfikator discord.
          </span>
        </div>
        Twój DiscordID:
        <input
          placeholder="304530787137617920"
          type="number"
          value={discordId}
          onChange={(e) => setDiscordId(e.target.value)}
        />
      </label>
      <label>
        Twój wiek:
        <input
          placeholder="21"
          type="number"
          value={age}
          onChange={(e) => setAge(e.target.value)}
        />
      </label>
      <label>
        Opisz swoją postać i podaj nam trochę informacji na jej temat:
        <textarea
          placeholder="Twoja odpowiedź..."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </label>
      <label>
        <div className="attention-box">
          <img src={attentionimage} alt="" />
          <h3>
            Oczekuje się, że członkowie WildLandsRP.pl którzy chcą zdać
            whitelist muszą spełniać ustalone standardy.
          </h3>
          <span>
            Zgodnie z naszym regulaminem, wymagamy od potencjalnych członków
            społeczności, którzy chcą zdać whitelist, aby spełniali określone
            standardy i wymagania. Przed przystąpieniem do procesu
            whitelistowania, zachęcamy do zapoznania się z regulaminem, gdzie
            znajdują się wszystkie wymagania dotyczące procesu whitelistowania.
            <br />
            <br />W razie pytań lub wątpliwości, zachęcamy do skontaktowania się
            z administracją serwera.
          </span>
        </div>
        Czym jest RolePlay i jakie są jego podstawowe zasady?
        <textarea
          placeholder="Twoja odpowiedź..."
          value={goodRoleplay}
          onChange={(e) => setGoodRoleplay(e.target.value)}
        />
      </label>
      <label>
        Podaj przykład, jak można rozpocząć interakcję z innym graczem:
        <textarea
          placeholder="Twoja odpowiedź..."
          value={interaction}
          onChange={(e) => setInteraction(e.target.value)}
        />
      </label>
      <label>
        Wymień dwa najważniejsze wydarzenia z tamtych czasów, które mogą wpłynąć
        na rozgrywkę:
        <textarea
          placeholder="Twoja odpowiedź..."
          value={events}
          onChange={(e) => setEvents(e.target.value)}
        />
      </label>
      <label>
        Jakie są główne cechy społeczne i kulturowe tamtych czasów, które należy
        uwzględnić podczas gry?
        <textarea
          placeholder="Twoja odpowiedź..."
          value={socialCulturalTraits}
          onChange={(e) => setSocialCulturalTraits(e.target.value)}
        />
      </label>
      <label>
        Jakie technologie są dostępne dla postaci w tamtych czasach?
        <textarea
          placeholder="Twoja odpowiedź..."
          value={technologies}
          onChange={(e) => setTechnologies(e.target.value)}
        />
      </label>
      <label>
        Czy jesteś gotów na interakcje RP (Role Play) z NPC (Non-Player
        Character), czy raczej skupiasz się tylko na interakcjach z innymi
        graczami?
        <textarea
          placeholder="Twoja odpowiedź..."
          value={npcInteraction}
          onChange={(e) => setNpcInteraction(e.target.value)}
        />
      </label>
      <label>
        Jak można zakończyć scenę roleplay, gdy nie czujesz się komfortowo z
        danej sytuacji?
        <textarea
          placeholder="Twoja odpowiedź..."
          value={uncomfortableScene}
          onChange={(e) => setUncomfortableScene(e.target.value)}
        />
      </label>
      <label>
        Opisz, jak powinieneś postępować, gdy twoja postać zostanie ranna w
        interakcji z innymi graczami:
        <textarea
          placeholder="Twoja odpowiedź..."
          value={injury}
          onChange={(e) => setInjury(e.target.value)}
        />
      </label>
      <label>
        Ile osób może jednocześnie przebywać w grupie bandytów lub szeryfów
        podczas odgrywania akcji hostylnych?
        <textarea
          placeholder="Twoja odpowiedź..."
          value={groupSize}
          onChange={(e) => setGroupSize(e.target.value)}
        />
      </label>
      <label>
        Twoja postać doznała pewnych obrażeń. Opisz co jej jest, tak jakbyś to
        zrobił pisząc opis stanu pacjenta:
        <textarea
          placeholder="Twoja odpowiedź..."
          value={injuryDescription}
          onChange={(e) => setInjuryDescription(e.target.value)}
        />
      </label>
      <label>
        Co masz zamiar grać na naszym serwerze:
        <textarea
          placeholder="Twoja odpowiedź..."
          value={ideas}
          onChange={(e) => setIdeas(e.target.value)}
        />
      </label>
      <label>
        Czy preferujesz grę samemu, w mniejszych grupach czy w większych
        zespołach? Dlaczego?
        <textarea
          placeholder="Twoja odpowiedź..."
          value={playStyle}
          onChange={(e) => setPlayStyle(e.target.value)}
        />
      </label>
      <label>
        <input
          placeholder="Twoja odpowiedź..."
          type="checkbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        <p>
          Przeczytałem <a href="">Regulamin</a>
        </p>
      </label>
      <button
        type="submit"
        disabled={!(isChecked && allFieldsAreFilled)}
        style={{
          opacity: isChecked && allFieldsAreFilled ? 1.0 : 0.3,
          cursor: isChecked && allFieldsAreFilled ? "pointer" : "not-allowed",
        }}
        title={isChecked && allFieldsAreFilled ? null : ""}
      >
        Wyślij
      </button>
    </form>
  );
};

export default Form;
